// Локализованное поле — карта «язык → текст». Общие операции над ней для всех фич.

// Пустые переводы в запрос не тащим — бэк хранит только заполненные локали.
export const trimLocalizedMap = (values: Record<string, string>): Record<string, string> =>
    Object.keys(values).reduce<Record<string, string>>((result, lang) => {
        const value = (values[lang] || "").trim();
        if (value) result[lang] = value;
        return result;
    }, {});

// Правка одного перевода. Вынесено, потому что иначе каждое локализованное поле формы
// повторяет `{ ...values, [lang]: value }` — а таких полей в форме бывает несколько.
export const setLocalizedValue = (
    values: Record<string, string>,
    lang: string,
    value: string
): Record<string, string> => ({ ...values, [lang]: value });

// Текст на языке кабинета, с откатом на любой заполненный перевод.
export const localizedText = (values: Record<string, string>, locale: string): string => {
    if (values[locale]) return values[locale];

    const filled = Object.keys(values).find((lang) => !!values[lang]);

    return filled ? values[filled] : "";
};

export const hasLocalizedValue = (values: Record<string, string>): boolean =>
    Object.keys(values).some((lang) => !!(values[lang] || "").trim());

// Поиск по локализованному полю идёт по всем переводам, а не по языку кабинета: позиция,
// названная только по-английски, иначе не находилась бы русским поиском.
export const matchesLocalizedQuery = (
    values: Record<string, string>,
    query: string
): boolean => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) return true;

    return Object.values(values).some((value) =>
        (value || "").toLowerCase().includes(normalized)
    );
};
